import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
import { getDataNotAvailableText, mappingHourKeys } from '../helpers/UsageDashboardHelper';
import { USAGE_SHC_EVENTS, TIMESCALE } from '../constants/common';
import { ButtonNext } from 'pure-react-carousel';
export const INSIGHTS_BILL_ANALYSIS_DATA_ACTIONS = {
  ERROR_USAGE_BILL_ANALYSIS_DATA: 'ERROR_USAGE_BILL_ANALYSIS_DATA',
  FETCH_USAGE_BILL_ANALYSIS_DATA: 'FETCH_USAGE_BILL_ANALYSIS_DATA',
  SIMILAR_HOMES_API_ERROR: "SIMILAR_HOMES_API_ERROR",
  SIMILAR_HOMES_SAVE_APPLIANCE_NAVBAR_LIST: "SIMILAR_HOMES_SAVE_APPLIANCE_NAVBAR_LIST",
  SIMILAR_HOMES_SAVE_CHART_API_PAYLOAD: "SIMILAR_HOMES_SAVE_CHART_API_PAYLOAD"
};


export const fetchBillAnalysisData = (options, userId) => async(dispatch) => {
  await axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + userId + '/bill-comparison', {
        params: options
    }).then(
      (response) => {
        dispatch({
          type: INSIGHTS_BILL_ANALYSIS_DATA_ACTIONS.FETCH_USAGE_BILL_ANALYSIS_DATA,
          payload: response
        })
      }
    ).catch(
      (error) => {
        dispatch({
          type: INSIGHTS_BILL_ANALYSIS_DATA_ACTIONS.ERROR_USAGE_BILL_ANALYSIS_DATA
        })
      }
    )
}

export function fetchBillUsageData(options, userId) {
  return axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + userId + '/usage-chart-data', {
      params: options
  }).then(res => {
    return res;
  }).catch(err => {
    return err;
  })
}

export function fetchHourData(t0,t1,mode) {
  let time1 = parseInt(t0);
  let time2 = parseInt(t1) + 1 ;
  return axios.get('https://ingest.bidgely.com/itron?t0=' + time1 + '&t1=' + time2 )
  .then(res => {
    let data = res.data;
    let response = [];
    let count = 0;
    for (const bc in data) {
      if (mode == 'Day' && (count % 10) != 0) {
        count += 1;
        continue;
      }
      count += 1;
      if (data.hasOwnProperty(bc)) {
        const applianceDetail = data[bc];
        let itemizationDetailsList = []
        for (const appId in applianceDetail) {
          if (applianceDetail.hasOwnProperty(appId)) {
            let applianceConsumption = applianceDetail[appId];
            let keyName = mappingHourKeys(appId);
            applianceConsumption = parseFloat(applianceConsumption);
            itemizationDetailsList.push({id: appId, category: keyName, usage: Math.round(applianceConsumption), cost: 0, percentage: 0})
          }
        }
        let prepareData = {
          consumption: 0,
          cost: 0,
          intervalEnd: bc,
          intervalEndDate: new Date(bc * 1000),
          intervalStart: bc,
          intervalStartDate: new Date(bc * 1000),
          isBoundaryInterval: false,
          isMissingDataInterval: false,
          isOngoingInterval: false,
          isTimestampPresent: null,
          isWeekend: null,
          itemizationDetailsList: itemizationDetailsList,
          temperature: 0
        };
        response.push(prepareData);
      }
    }
    return {data: {payload: response}};
    }).catch(err => {
      return err;
    })
}

export const fetchSHCGraphData = (options, userId, insightsSHData, translations, applianceList) => async(dispatch) => {
  await axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + userId + '/shc-appliance-graph-data', {
      params: options
  }).then(response => {
    //Save appliance navbar for SHC page
    let appliancesSHCList = response.data.payload.shcApplianceData.applianceList.map( item => {
      if (applianceList[item]) {
          return {id: item, name: applianceList[item]};
      }
    }).filter(item => item !== undefined);
    dispatch({
      type: INSIGHTS_BILL_ANALYSIS_DATA_ACTIONS.SIMILAR_HOMES_SAVE_APPLIANCE_NAVBAR_LIST,
      payload: {
        appliancesSHCList,
        usageChartEvent: USAGE_SHC_EVENTS.SAVE_APPLIANCE_NAVBAR_LIST
      }
    })

    //Save shc data object
    dispatch({
      type: INSIGHTS_BILL_ANALYSIS_DATA_ACTIONS.SIMILAR_HOMES_SAVE_CHART_API_PAYLOAD,
      payload: {
        shcGraphData: response.data.payload.shcGraphData,
        usageChartEvent: USAGE_SHC_EVENTS.SAVE_CHART_API_PAYLOAD
      }
    })
  }).catch(error => {
    let dataNotAvailableText = getDataNotAvailableText(insightsSHData, translations);
    dispatch({
      type: INSIGHTS_BILL_ANALYSIS_DATA_ACTIONS.SIMILAR_HOMES_API_ERROR,
      payload: {
        dataNotAvailableText,
        usageChartEvent: USAGE_SHC_EVENTS.SIMILAR_HOMES_API_ERROR
      }
    })
  })
}

export function fetchSHComparisonInfoData(options, userId) {
  return axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + userId + '/shc-comparison-widget-data', {
      params: options
  }).then(response => {
    return response;
  }).catch(err => {
    return err;
  })
}
